import React, { createContext, useContext } from "react";
import { usersQuery, usersStore } from "../states";

let operationsAllowed: any = {};
const UsersServiceContext = createContext(operationsAllowed);

export const UsersServiceProvider = (props: any) => {
  
  const getUserListLayout = () => {
    return usersQuery.getValue().listPage.layout;
  }

  const setUserListLayout = (layout: string) => {
    usersStore.update({listPage: {layout: layout}});
  }

  operationsAllowed = {
    getUserListLayout,
    setUserListLayout
  }

  return (
    <UsersServiceContext.Provider value={operationsAllowed}>
      {props.children}
    </UsersServiceContext.Provider>
  );
}

export const useUsersService = () => {
  return useContext(UsersServiceContext);
}